import React from 'react';
import {useTranslation} from "react-i18next";

const NoApiKeySelected = () => {

    const { t } = useTranslation();

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
                <span
                    style={{
                        fontSize: '14px',
                        color: '#757575'
                    }}
                >
                    {t("menu.franchiseApiKey.detail.message.selectKey")}
                </span>
        </div>
    );
};

export default NoApiKeySelected;